export function createFileNameFromImageURL(imageURL: string) {
  return imageURL.split('/').slice(-1)[0] ?? 'cropped.jpg';
}
